import React from 'react';

import { theme } from '../../../../tailwind.config';
import { IIconProps } from 'ui/CircleIconButton';

export const MapPinFilledIcon: React.FC<IIconProps> = React.memo(
  ({ fill = theme.colors['brown-100'], background = 'transparent' }) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ backgroundColor: background }}
    >
      <path
        d="M18.364 4.63606C20.0163 6.28819 20.9613 8.51817 20.9992 10.8545C21.0371 13.1908 20.1649 15.4502 18.567 17.1551L18.364 17.3651L14.121 21.6071C13.5826 22.1451 12.8599 22.4584 12.0991 22.4834C11.3384 22.5085 10.5966 22.2435 10.024 21.7421L9.87999 21.6071L5.63599 17.3641C3.94816 15.6762 2.99994 13.387 2.99994 11.0001C2.99994 8.61309 3.94816 6.32389 5.63599 4.63606C7.32383 2.94822 9.61303 2 12 2C14.387 2 16.6762 2.94822 18.364 4.63606ZM12 8.00006C11.606 8.00006 11.2159 8.07765 10.8519 8.22842C10.488 8.37918 10.1572 8.60016 9.87867 8.87873C9.6001 9.15731 9.37912 9.48803 9.22836 9.85201C9.07759 10.216 8.99999 10.6061 8.99999 11.0001C8.99999 11.394 9.07759 11.7841 9.22836 12.1481C9.37912 12.5121 9.6001 12.8428 9.87867 13.1214C10.1572 13.4 10.488 13.6209 10.8519 13.7717C11.2159 13.9225 11.606 14.0001 12 14.0001C12.7956 14.0001 13.5587 13.684 14.1213 13.1214C14.6839 12.5588 15 11.7957 15 11.0001C15 10.2044 14.6839 9.44134 14.1213 8.87873C13.5587 8.31613 12.7956 8.00006 12 8.00006Z"
        fill={fill}
      />
    </svg>
  )
);

export default MapPinFilledIcon;
